import { render, staticRenderFns } from "./SendResetContent.vue?vue&type=template&id=69a8f6e4&"
import script from "./SendResetContent.vue?vue&type=script&lang=js&"
export * from "./SendResetContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports